import { Component, OnInit } from "@angular/core";
import { ToastrService } from "ngx-toastr";
import { TableName } from "src/app/npr-request.model";
import { ApiService } from "src/app/services";
import { ModalService } from "src/app/shared/modal.service";
import { BlueprintConfig } from "src/app/generated-models/BlueprintConfig";
import { SharedDataService } from "../../services/sharedDataService";
import { DataTypes } from "./admin-view-data-types";
import { AdminViewComponent } from "./admin-view.component";
import { BlueprintConfigColumnDefinitionForAdmin } from "./ag-grid-column-definition";

@Component({
  standalone: false,
  selector: "admin-view/blueprint",
  templateUrl: "./admin-view.component.html",
  styleUrls: ["../../styles.scss"],
})
export class AdminViewBlueprintConfigComponent extends AdminViewComponent<BlueprintConfig> implements OnInit {
  type = "Blueprint Config";
  tableName = TableName.BlueprintConfig;
  columnDef = BlueprintConfigColumnDefinitionForAdmin;

  keyFilterStats = "filter:admin-view-blueprint-config";

  constructor(
    apiService: ApiService,
    modalService: ModalService,
    notificationService: ToastrService,
    sharedDataService: SharedDataService,
    dataTypes: DataTypes
  ) {
    super(apiService, modalService, notificationService, sharedDataService, dataTypes);
    this.addRowEnable = true;
    this.addRowFunc = (data) => apiService.setBlueprintConfig(data as BlueprintConfig).toPromise();
    this.updateRowFunc = (data) => apiService.setBlueprintConfig(data as BlueprintConfig).toPromise();
    this.deleteRowEnable = true;
    this.deleteRowFunc = (data: BlueprintConfig) => 
      apiService.deleteBlueprintConfig(data.ServiceTreeId, data.Blueprint, data.Region).toPromise();
  }

  refreshData(): void {
    super.refreshData();
    this.apiService.getBlueprintConfig().subscribe((response) => {
      this.setRowData(response);
      super.setupFilterByLocalData();
    });
  }
}
